import { Paper, Typography } from "@material-ui/core";
import { IconAlertCircle } from "@tabler/icons-react";

export default function TableErrorMessage() {
  return (
    <div>
      <Paper variant="outlined">
        <div
          style={{
            minHeight: 400,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              padding: 10,
              backgroundColor: "#FCF8E8",
              borderRadius: 40,
              height: 80,
            }}
          >
            <IconAlertCircle size={60} color="#FFC55C" stroke={1.4} />
          </div>
          <br />
          <Typography variant="h6" color="textSecondary">
            Ocurrio un error. Intente luego
          </Typography>
          <Typography variant="caption" style={{ fontFamily: 'monospace'}} color="textSecondary">
            [00025-230001-69354-0x00101]
          </Typography>
        </div>
      </Paper>
      <br/>
    </div>
  );
}
